export default __webpack_public_path__ + "static/media/cert-senior-manager-cpttm.643b7c95.jpg";